import { AUTH_BASE_URL } from "@/common/config";

interface AvatarDebugInfo {
  input: string | undefined;
  apiBaseUrl: string | undefined;
  isHttp: boolean | undefined;
  result: string;
}

/**
 * Constructs the full URL for an avatar image
 * @param avatarUrl - The relative or absolute URL of the avatar
 * @param defaultImage - Optional default image path (defaults to "/images/profile.png")
 * @returns The complete URL for the avatar image
 */
export const getAvatarUrl = (avatarUrl?: string, defaultImage = "/images/profile.png"): string => {
  // Check for missing API_BASE_URL
  if (!AUTH_BASE_URL) {
    console.error("API_BASE_URL is not defined!", {
      env: import.meta.env,
      VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
    });
  }

  // Debug information
  const debugInfo: AvatarDebugInfo = {
    input: avatarUrl,
    apiBaseUrl: AUTH_BASE_URL,
    isHttp: avatarUrl?.startsWith("http"),
    result: avatarUrl ? (avatarUrl.startsWith("http") ? avatarUrl : `${AUTH_BASE_URL}${avatarUrl}`) : defaultImage,
  };
  console.log("Avatar URL Debug:", debugInfo);

  // URL construction logic
  if (!avatarUrl) return defaultImage;
  // if (!AUTH_BASE_URL) return defaultImage;
  if (avatarUrl?.startsWith("http")) return avatarUrl;
  return `${AUTH_BASE_URL}${avatarUrl}`;
};
